import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import { navigateToView } from '../../Account/util/views';
import { ACCOUNT_HOME_VIEW } from '../../Account/util/views';
import ProfileListRow from './ProfileListRow';
import styled from 'styled-components';
import { colors } from '../../../constants/colors';
import { analyticsTrackEvent } from '../../../core/analytics';
import { Actions, Events } from '../../Account/util/analytics';
import ProfileDeletionDialog from './ProfileDeletionDialog';
import { getProfileColorTheme } from '../../Account/util/colors';

const Profiles = styled(List)`
  border: 1px solid ${colors.borderLine};
  background: ${colors.theWhiteAlbum};
`;

const Item = styled.div`
  margin: 0;
  padding: 0;

  :last-child {
    border-bottom: none;
  }
`;

const StyledDivider = styled(Divider)`
  color: ${colors.justAnotherGray};
  margin: 0 0 0 72px;
`;

class ProfileList extends PureComponent {
  static propTypes = {
    accountSummary: PropTypes.object,
    currentProfile: PropTypes.object,
    deleteUserProfile: PropTypes.func,
    isInEditMode: PropTypes.bool,
    onSelect: PropTypes.func,
  };

  static defaultProps = {
    accountSummary: { user_profiles: [] },
    currentProfile: {},
  };

  state = {
    deleteOpen: false,
    userProfileToDelete: null,
    edit: false,
  };

  getProfileCount = accountSummary =>
    accountSummary && accountSummary.user_profiles && accountSummary.user_profiles.length;

  handleListItemClick = (e, userProfile) => {
    if (this.props.isInEditMode) {
      return this.handleDeleteOpen(userProfile);
    }

    const { accountSummary } = this.props;
    analyticsTrackEvent(Events.ACCOUNT_NAVIGATION, {
      action: Actions.PROFILE_SELECTOR,
      label: 'Touch Profile',
      numberOfProfiles: this.getProfileCount(accountSummary),
    });

    this.props.onSelect(userProfile);
    return navigateToView(ACCOUNT_HOME_VIEW, userProfile.user_profile_id);
  };

  handleDeleteOk = e => {
    e && e.stopPropagation();
    this.props.deleteUserProfile(this.state.userProfileToDelete.user_profile_id);
    this.setState({ userProfileToDelete: null, deleteOpen: false });
  };

  handleDeleteCancel = e => {
    e && e.stopPropagation();
    this.setState({ deleteOpen: false });
  };

  handleDeleteOpen = userProfile => {
    this.setState({ userProfileToDelete: userProfile, deleteOpen: true });
  };

  render = () => {
    const { accountSummary, isInEditMode } = this.props;

    return (
      <div>
        <Profiles>
          {this.getProfileCount(accountSummary) > 0 &&
            accountSummary.user_profiles
              .filter(profile => profile.is_verified)
              .map((p, i) => (
                <Fragment key={p.user_profile_id}>
                  <Item onClick={e => this.handleListItemClick(e, p)}>
                    <ProfileListRow
                      userProfile={p}
                      isVerified={p.is_verified}
                      profileColor={getProfileColorTheme(accountSummary, p.user_profile_id).primary}
                      relationshipToAccount={p.relationship_to_account}
                      openDeleteProfile={this.handleDeleteOpen}
                      showTrashCan={isInEditMode}
                    />
                  </Item>
                  {i + 1 < accountSummary.user_profiles.length && <StyledDivider />}
                </Fragment>
              ))}
        </Profiles>

        <ProfileDeletionDialog
          open={this.state.deleteOpen}
          onClose={this.handleDeleteCancel}
          handleProfileDeletion={this.handleDeleteOk}
          userProfile={this.state.userProfileToDelete}
        />
      </div>
    );
  };
}

export default ProfileList;
